import { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";

const baseUrl = `${BASE_URL}/master`;

const getProductQuotaById = async (quotaId: string) => {
  return await httpClient
    .get(`${baseUrl}/product-quota/quota-detail/${quotaId}`, { params: { quotaId } })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getProductQuotaList = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/product-quota/quota-list`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const changeStatusProductQuota = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/update-status-quota`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const deleteProductQuota = async (params: object) => {
  return await httpClient
    .delete(`${baseUrl}/product-quota/delete-quota`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getProductQuotaProduct = async (params: {
  quotaId: string;
  searchProduct?: string;
  searchShop?: string;
  zone?: string;
  sortField?: string;
  sortDirection?: string;
  page?: number;
  take?: number;
}) => {
  return await httpClient
    .get(`${baseUrl}/product-quota/quota-product-shop`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const createProductQuota = async (data: any) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/create-quota`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateProductQuota = async (data: any) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/update-quota`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const deleteQuotaProductQuota = async (data: any) => {
  return await httpClient
    .patch(`${baseUrl}/product-quota/delete-quota-product-shop`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const checkProductShop = async (data: any) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/check-product-shop`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const checkDupProductQuota = async (data: any) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/check-duplicate-product-quota`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const checkDupPDQuotaDetail = async (data: any) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/duplicate-product-quota-detail`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const historyProductQuota = async (params: { quotaId: any; page: number; take: number }) => {
  return await httpClient
    .get(`${baseUrl}/product-quota/history-quota`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getProductQuotaTotal = async (params: {
  quotaId: string;
  quotaTotalType: string;
  searchProduct?: string;
  searchShop?: string;
  zone?: string;
  searchGroupCustomer?: string;
  sortField?: string;
  sortDirection?: string;
  page?: number;
  take?: number;
}) => {
  return await httpClient
    .get(`${baseUrl}/product-quota/quota-total-product-shop`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getProductQuotaGroup = async (params: {
  quotaId: string;
  searchProduct?: string;
  page?: number;
  take?: number;
}) => {
  return await httpClient
    .get(`${baseUrl}/product-quota/quota-product-shop-group`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const createProductQuotaGroup = async (data: any) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/create-quota-group`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateProductQuotaGroup = async (data: any) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/update-quota-total-group`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getQuotaTotalGroup = async (quotaId: string) => {
  return await httpClient
    .get(`${baseUrl}/product-quota/get-quota-total-group-detail/${quotaId}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateQuotaGroupForDuplicate = async (data: any) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/duplicate-quota-total-group`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateShopStatus = async (object: object) => {
  return await httpClient
    .post(`${baseUrl}/product-quota/update-shop-status/`, object)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const reportQuotaUsed = async (object: object) => {
  return await httpClient
    .post(`${baseUrl}/report-quota/excel-report-quota-used`, object, {
      responseType: "arraybuffer",
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const reportQuotaTransaction = async (object: object) => {
  return await httpClient
    .post(`${baseUrl}/report-quota/excel-quota-transaction`, object, {
      responseType: "arraybuffer",
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

export {
  getProductQuotaById,
  getProductQuotaProduct,
  createProductQuota,
  updateProductQuota,
  getProductQuotaList,
  changeStatusProductQuota,
  deleteProductQuota,
  deleteQuotaProductQuota,
  checkProductShop,
  historyProductQuota,
  checkDupProductQuota,
  getProductQuotaTotal,
  getProductQuotaGroup,
  createProductQuotaGroup,
  getQuotaTotalGroup,
  updateProductQuotaGroup,
  updateShopStatus,
  checkDupPDQuotaDetail,
  reportQuotaUsed,
  reportQuotaTransaction,
  updateQuotaGroupForDuplicate,
};
